import { Profile, RingType } from '@ringo/types'
import { FilterFavoritePositionsRingConfigTypesEnum } from '../generated'

export function getRingDetailsPreviewName(profile: string | number, t: any) {
    switch (profile) {
        case Profile.Profile0:
        case Profile.Profile1:
        case Profile.Profile2:
        case Profile.Profile3:
        case Profile.Profile4:
        case Profile.Profile5:
        case Profile.Profile6:
        case Profile.Profile7:
        case Profile.Profile8:
        case Profile.Profile9:
        case Profile.Profile10:
        case Profile.Profile11:
        case Profile.Profile12:
        case Profile.Profile13:
        case Profile.Profile14:
        case Profile.Profile16:
        case Profile.Profile17:
        case Profile.Profile71:
            return t('profile') + ' ' + profile

        case Profile.Tube:
            return t('tube')

        case Profile.Sinterring:
            return t('NormalSintering')

        case Profile.SinterringAxial:
            return t('AxialSintering')

        default:
            return 'unknownProfile'
    }
}

export function isSinterringAxial(ringProfile: Profile) {
    return ringProfile === Profile.SinterringAxial
}

export function isSinterringNormal(ringProfile: Profile) {
    return ringProfile === Profile.Sinterring
}

export function isSinterring(ringProfile: Profile) {
    return isSinterringAxial(ringProfile) || isSinterringNormal(ringProfile)
}

export function isTube(ringProfile: Profile) {
    return ringProfile === Profile.Tube
}

export function isProfileRing(ringProfile: Profile) {
    return !isSinterring(ringProfile) && !isTube(ringProfile)
}

export function getProfileFromRingType(ringType: RingType) {
    switch (ringType) {
        case RingType.TUBE:
            return Profile.Tube
        case RingType.PROFILERING:
            return Profile.Profile0
        case RingType.SINTERRING:
            return Profile.Sinterring
    }
    return undefined
}

export function getRingTypeFromProfile(profile: Profile) {
    if (isSinterringAxial(profile)) {
        return RingType.SINTERRING_AXIAL
    } else if (isSinterringNormal(profile)) {
        return RingType.SINTERRING
    } else if (profile === Profile.Tube) {
        return RingType.TUBE
    } else {
        return RingType.PROFILERING
    }
}

export function getSinterringTypeFromProfile(profile: Profile): 'AXIAL_SINTERING' | 'NORMAL_SINTERING' | null {
    if (profile === Profile.Sinterring) {
        return 'NORMAL_SINTERING'
    } else if (profile === Profile.SinterringAxial) {
        return 'AXIAL_SINTERING'
    }
    return null
}

export function getProfileFromSinterringType(type: 'AXIAL_SINTERING' | 'NORMAL_SINTERING'): Profile {
    if (type === 'NORMAL_SINTERING') {
        return Profile.Sinterring
    } else if (type === 'AXIAL_SINTERING') {
        return Profile.SinterringAxial
    }
    throw new Error('Not supported Sinterring type')
}

export function getProfileFullName(profile: Profile, t: any) {
    if (isProfileRing(profile)) {
        return `${t('profile')} ${profile}`
    } else if (isSinterringAxial(profile)) {
        return t('sinterRingAxial')
    } else if (isSinterringNormal(profile)) {
        return t('sinterRingNormal')
    } else if (isTube(profile)) {
        return t('tube')
    }
}

export function getFavoriteRingTypeFromProfile(profile: Profile) {
    if (isProfileRing(profile)) {
        return FilterFavoritePositionsRingConfigTypesEnum.Profil
    } else if (isSinterringAxial(profile)) {
        return FilterFavoritePositionsRingConfigTypesEnum.AxialSintering
    } else if (isSinterringNormal(profile)) {
        return FilterFavoritePositionsRingConfigTypesEnum.NormalSintering
    } else if (isTube(profile)) {
        return FilterFavoritePositionsRingConfigTypesEnum.Tube
    }
    return undefined
}
